export default {
  methods: {
    getLocaleString(str) {
      return typeof str !== 'object'
        ? this.$i18n.te(str)
          ? this.$i18n.t(str)
          : str
        : '';
    },
  },
};
